import { flatten } from 'lodash';
import { getDefaultReasonCodes } from 'utils/ReasonCodesAPI';

export const isValidInvoiceForCreditMemo = (invoice) => {
  if (!invoice) {
    return false;
  }
  const { invoice_type, type } = invoice;

  if (invoice_type !== 'debit' || type !== 'drayage') {
    return false;
  }

  const negativeItems = flatten(
    invoice.lineItemGroups.map((lineItemGroup) =>
      lineItemGroup?.lineItems.filter((lineItem) => lineItem?.value < 0),
    ),
  );

  if (negativeItems.length) return false;

  return true;
};

export const transformPayload = (data, shipment, invoice) => {
  let charges = data.adjustedItems.map((item) => item._id);
  const groupedChargeTypes = invoice?.lineItemGroups?.find(lineItemGroup => lineItemGroup.shipment_id.toString() === shipment._id.toString())?.groupedChargeTypes || []
  const selectedCharges = {
    [shipment._id]: {
      selected: charges,
      groupedChargeTypes,
    },
  };
  return selectedCharges;
};

export const transformRebillData = (data, shipment) => {
  let rebilledItems = data.adjustedItems.reduce((rebillData, adjustedItem) => {
    rebillData[adjustedItem._id] = {
      ...adjustedItem,
      reason_code: adjustedItem.reasonCode,
      notes: adjustedItem.notes,
      shipper_unit_qty: adjustedItem.units,
      shipper_rate: data.rebill ? adjustedItem.amount : 0,
      type: adjustedItem.type,
      billing_type: adjustedItem.billing_type,
      value: adjustedItem.total_amount,
    };
    if (adjustedItem.type === 'shipper_cost') {
      delete rebillData[adjustedItem._id].shipper_unit_qty;
      delete rebillData[adjustedItem._id].shipper_rate;
    }
    return rebillData;
  }, {});
  const rebillInformation = {
    [shipment._id]: {
      rebill_required: data.rebill,
      ...rebilledItems,
    },
  };
  return rebillInformation;
};

export const fetchCreditMemoReasonCodes = async () => {
  const result = await getDefaultReasonCodes();
  const cmReasonCodes = result
    .find((x) => x.lineOfBusiness === 'drayage' && x.default)
    ?.categories.find((category) => category.name === 'credit_memo')
    ?.subCategories.find(
      (subCategory) => subCategory.reasonType === 'Reason Codes',
    )?.reasonCodes;

  if (cmReasonCodes && cmReasonCodes.length) {
    return cmReasonCodes;
  }
  return [];
};
